Vue.component("map-view", {
	props: {
		results: Array,
		"map-loaded": Boolean,
		position: [String, Object],
	},
	template: `
	<div class="google-map" id="search-result-map">
		<p class="loading" v-if="!results.length">読み込み中...</p>
	</div>
	`,
	data() {
		return {
			store,
			rendered: false,
			infoWindow: null,
			markers: [],
		};
	},
	watch: {
		results() {
			const {store} = this;
			if (store.mapLoaded && this.results && !this.rendered) {
				this.initMap();
			}
		}
	},
	mounted() {
		const {store} = this;
		if (store.mapLoaded && this.results && !this.rendered) {
			this.initMap();
		}
	},
	methods: {
		initMap() {
			var me = this, position, mapE, map, bounds, bath, vx, vy;

			position = new google.maps.LatLng(36.740614, 136.757286);
			if (me.position !== "auto") {
				position = new google.maps.LatLng(me.position.lat, me.position.lng);
			}

			mapE = document.getElementById("search-result-map");
			map = new google.maps.Map(mapE, {
				zoom: 9,
				minZoom: 8,
				center: position,
				fullscreenControl: false,
				clickableIcons: false,
				gestureHandling: "greedy", // Ctrl を押さずにホイールでズーム
			});

			me.infoWindow = ShopInfoWindow.create();

			bounds = new google.maps.LatLngBounds();
			me.results.forEach(bath => {
				const position = new google.maps.LatLng(bath.lat, bath.lng);
				const marker = new google.maps.Marker({map, position});

				// クリックでポップアップを開く
				marker.addListener("click", () => {
					me.infoWindow.open(map, marker, bath);
				});

				me.markers.push(marker);
				bounds.extend(position);
			});

			if (me.results.length === 1) {
				bath = me.results[0];
				vx = 0.005;
				vy = 0.002;
				bounds.extend(new google.maps.LatLng(bath.lat + vy, bath.lng + vx));
				bounds.extend(new google.maps.LatLng(bath.lat - vy, bath.lng - vx));
			}

			if (me.position === "auto" && me.results.length > 0) {
				map.fitBounds(bounds);
			}
			// TODO: 現在地から検索した場合の表示の調整

			// 地図の何もないところをクリックしたらポップアップを閉じる
			map.addListener("click", () => {
				if (me.infoWindow) {
					me.infoWindow.close();
				}
			});

			me.rendered = true;
		}
	},
});
